function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 25
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 25,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2358 6952)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M646.373,346.4c0-.826,0-1.652,0-2.478,0-.143-.006-.241-.18-.3a2.352,2.352,0,0,1-1.766-2.428q-.031-2.369,0-4.739a2.375,2.375,0,0,1,2.434-2.36c1.064,0,2.127,0,3.191,0a2.42,2.42,0,0,1,2.538,2.438c.034,1.62.026,3.242,0,4.863a2.359,2.359,0,0,1-1.637,2.221c-.267.09-.314.222-.312.468.009,1.477-.04,2.955.016,4.429a1.941,1.941,0,0,1-2.272,2.238,2,2,0,0,1-1.6-.667,2.026,2.026,0,0,1-.416-1.33C646.37,347.969,646.373,347.184,646.373,346.4Z",
  transform: "translate(-2989.079 -7278.754)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.4,350.814c0-.506,0-1.012,0-1.518a1.43,1.43,0,0,1,1.36-1.486c.793-.04,1.591-.038,2.385,0a1.5,1.5,0,0,1,1.394,1.546q.033,1.518,0,3.036a1.463,1.463,0,0,1-1.015,1.416.274.274,0,0,0-.206.317c0,.981,0,1.962,0,2.944A1.109,1.109,0,0,1,724.1,358.3a2.632,2.632,0,0,1-.764-.071,1.107,1.107,0,0,1-.742-1.165c0-.971-.007-1.942,0-2.913a.327.327,0,0,0-.255-.372,1.362,1.362,0,0,1-.936-1.3c-.017-.557,0-1.115,0-1.673Z",
  transform: "translate(-3056.519 -7290.745)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596.246,350.9c0,.5.009.992,0,1.488a1.458,1.458,0,0,1-.96,1.421.344.344,0,0,0-.246.391c.008.94,0,1.88.006,2.82a1.155,1.155,0,0,1-.635,1.208,1.638,1.638,0,0,1-1.576-.083,1.072,1.072,0,0,1-.482-.984c0-1,0-2,0-3.007,0-.157-.017-.259-.2-.325a1.459,1.459,0,0,1-1.017-1.474c-.01-1-.016-2,0-3.007a1.472,1.472,0,0,1,1.469-1.463c.732-.028,1.467-.027,2.2,0a1.478,1.478,0,0,1,1.433,1.465C596.256,349.863,596.245,350.38,596.246,350.9Z",
  transform: "translate(-2942.401 -7290.818)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M658.849,293.348a2.31,2.31,0,1,1,2.314,2.332A2.312,2.312,0,0,1,658.849,293.348Z",
  transform: "translate(-3001.724 -7241.041)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554.893,362.343c0-.165,0-.331,0-.5.009-.346.052-.669-.4-.837a.758.758,0,0,1-.379-.764c-.007-.609-.014-1.219,0-1.828a.933.933,0,0,1,.97-.953q.65-.013,1.3,0a.9.9,0,0,1,.948.87c.032.669.019,1.342,0,2.012a.827.827,0,0,1-.53.774.348.348,0,0,0-.236.4c.012.547.007,1.095,0,1.642s-.28.809-.864.8a.722.722,0,0,1-.82-.816C554.892,362.88,554.893,362.612,554.893,362.343Z",
  transform: "translate(-2909.97 -7299.225)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774.042,359.355c0-.309-.007-.619,0-.929a.944.944,0,0,1,.963-.959c.433-.01.867-.009,1.3,0a.928.928,0,0,1,.958.9c.024.669.015,1.341,0,2.011a.807.807,0,0,1-.524.743.348.348,0,0,0-.232.4c.011.547.007,1.094,0,1.64s-.288.811-.864.808a.72.72,0,0,1-.822-.811c0-.568.008-1.135-.01-1.7a.4.4,0,0,0-.185-.287,1,1,0,0,1-.587-.943C774.039,359.933,774.042,359.644,774.042,359.355Z",
  transform: "translate(-3102.632 -7299.225)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.579,320.685a1.473,1.473,0,1,1-1.49,1.466A1.488,1.488,0,0,1,601.579,320.685Z",
  transform: "translate(-2950.251 -7267.009)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.18,322.147a1.472,1.472,0,1,1-1.491-1.463A1.485,1.485,0,0,1,733.18,322.147Z",
  transform: "translate(-3064.261 -7267.009)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559.87,341.455a.913.913,0,1,1,.914.93A.916.916,0,0,1,559.87,341.455Z",
  transform: "translate(-2915.017 -7284.402)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M781.571,341.478a.917.917,0,1,1-.907-.939A.924.924,0,0,1,781.571,341.478Z",
  transform: "translate(-3107.624 -7284.402)",
  fill: "#bdbdbd"
})));

var SvgTime = function SvgTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time.5619d5a4.svg";
export { ForwardRef as ReactComponent };